import React from "react";
import {
  Row,
  Col,
  Container,
  InputGroup,
  Button,
  Table,
} from "react-bootstrap";
import lodash from "lodash";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import { id as CreateProjectId } from "../../../components/CreateProject/CreateProject";
import {
  getProjectAssignmentView,
  saveDefaults,
  setDefaultProject,
  setDefaultTask,
  changeProjectName,
  changeProjectMembers,
  getTaskList,
  saveProjectData,
} from "./../../../Slices/orgAdminSlice";
import { showModal, showSpinner } from "./../../../Slices/sessionSlice";
import styles from "./ProjectAssignment.module.css";
import SpinnerButton from "./../../../components/SpinnerButton/SpinnerButton";

import { id as CreateTaskId } from "../../../components/CreateTask/CreateTask";

const saveDefaultId = "save.Defaults";
const saveProjectDetailsId = "save.ProjectDetails";

const ProjectAssignmentView = () => {
  const dispatch = useDispatch();
  const {
    defaultProject,
    defaultTask,
    projectData,
    taskList,
    projectNames,
    members,
    projectMembers,
  } = useSelector((state) => state.orgAdminSlice);

  // #region Use Effect
  React.useEffect(() => {
    dispatch(getProjectAssignmentView());
  }, [dispatch]);
  // #endregion

  const getNewTaskList = (defaultProject, taskList) => {
    if (defaultProject.length === 0) {
      return taskList;
    } else {
      return taskList.filter(
        (task) => task.project._id === defaultProject.at(0)._id
      );
    }
  };

  const isSaveDisabled = !(
    defaultProject.length !== 0 && defaultTask.length !== 0
  );

  const canSave = () => {
    const changedMembers = projectMembers.filter(
      (item) => !lodash.isEqual(item.members, item.oldMembers)
    );
    const changedProjectNames = projectNames.filter(
      (item) => !lodash.isEqual(item.oldName, item.newName)
    );
    if (changedMembers.length !== 0 || changedProjectNames.length !== 0) {
      return false;
    }
    return true;
  };

  return (
    <>
      <Container className="mb-6">
        <Row className="shadow p-3 mb-5 mt-3 bg-body rounded">
          <Col sm={"2"}></Col>
          <Col>
            <InputGroup className="mb-3">
              <InputGroup.Text id="basic-addon1">
                Default Project
              </InputGroup.Text>
              <Typeahead
                id="basic-typeahead-single"
                labelKey="name"
                onChange={(val) => {
                  dispatch(setDefaultProject(val));
                  dispatch(setDefaultTask([]));
                }}
                options={projectData}
                placeholder="Choose a Default Project"
                selected={defaultProject}
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text
                id="basic-addon1"
                className={`${styles.default_task}`}
              >
                {"Default Task "}
              </InputGroup.Text>
              <Typeahead
                id="basic-typeahead-single"
                labelKey="name"
                onChange={(val) => {
                  dispatch(setDefaultTask(val));
                  if (val.length !== 0 && val.at(0).project) {
                    dispatch(setDefaultProject([val.at(0).project]));
                  }
                }}
                options={getNewTaskList(defaultProject, taskList)}
                placeholder="Choose a Default Task"
                selected={defaultTask}
              />
            </InputGroup>
            <Row>
              <Col className="text-end">
                <SpinnerButton
                  disabled={isSaveDisabled}
                  variant="outline-success"
                  id={saveDefaultId}
                  onClick={() => {
                    const payload = {
                      project: defaultProject.at(0)._id,
                      task: defaultTask.at(0)._id,
                    };
                    dispatch(showSpinner({ id: saveDefaultId }));
                    dispatch(saveDefaults(payload));
                  }}
                  name="Save"
                />
              </Col>
            </Row>
          </Col>
          <Col sm={"2"}></Col>
        </Row>
        <Row>
          <Table hover>
            <thead>
              <tr className="text-center">
                <th>Project</th>
                <th>Members</th>
              </tr>
            </thead>
            <tbody>
              {projectData.map((item, index) => {
                const [structuredMembers] = projectMembers.filter(
                  (mem) => mem._id === item._id
                );

                const [currentProject] = projectNames.filter(
                  (proj) => proj._id === item._id
                );
                console.log("Current project :- ", currentProject);
                return (
                  <tr key={`row - ${index}`}>
                    <td key={`col :- ${index}`} className="align-middle">
                      <div className="input-group mb-3">
                        <input
                          type="search"
                          className="form-control hide-focus border-0 bg-white align-middle"
                          placeholder="Search"
                          aria-label="Project Name"
                          name={`${item._id}`}
                          aria-describedby="basic-addon1"
                          value={currentProject.newName}
                          onChange={(e) => {
                            dispatch(
                              changeProjectName({
                                _id: currentProject._id,
                                value: e.target.value,
                              })
                            );
                          }}
                        />
                      </div>
                    </td>
                    <td key={`member - ${index}`}>
                      <Typeahead
                        key={index}
                        id="basic-typeahead-multiple"
                        labelKey={"fullName"}
                        multiple
                        onChange={(val) => {
                          console.log("val :- ", val);
                          dispatch(
                            changeProjectMembers({ projectId: item._id, val })
                          );
                        }}
                        options={members}
                        placeholder="Choose Project members..."
                        selected={structuredMembers.members}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Row>
        <Row className="mb-4">
          <Col sm={"6"}>
            <div className="d-flex justify-content-around ">
              <Button
                variant="outline-primary"
                className={"ml-4"}
                href="#"
                onClick={() =>
                  dispatch(showModal({ id: CreateProjectId, data: null }))
                }
              >
                {"+ project"}
              </Button>
              <Button
                variant="outline-primary"
                className="ml-4"
                onClick={() => {
                  const payload = projectNames.map((item) => ({
                    projectId: item._id,
                    name: item.oldName,
                  }));
                  dispatch(showModal({ id: CreateTaskId, data: payload }));
                }}
              >
                {"+ task"}
              </Button>
            </div>
          </Col>
          <Col className="text-end">
            <SpinnerButton
              disabled={canSave()}
              variant="outline-success"
              className={"ml-4"}
              id={saveProjectDetailsId}
              onClick={() => {
                const changedMembers = projectMembers.filter(
                  (item) => !lodash.isEqual(item.members, item.oldMembers)
                );
                const changedProjectNames = projectNames.filter(
                  (item) => !lodash.isEqual(item.oldName, item.newName)
                );
                dispatch(showSpinner({ id: saveProjectDetailsId }));
                dispatch(
                  saveProjectData({ changedMembers, changedProjectNames })
                );
              }}
              name="save"
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProjectAssignmentView;
